import { Box, Spacer } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';
import { HeadingWithEmphasis } from '~/components/heading-with-emphasis';
import { Markdown } from '~/components/markdown';
import { SanityImage } from '~/components/sanity-image';
import { Section } from '~/components/section';
import { TemplateButton } from '~/components/template-button';
import { SanityImageType } from '~/features/page-template/models/image';
import { TemplateButton as TemplateButtonProps } from '~/features/page-template/models/template-button';

export type MeetMentorsSectionProps = {
  title: string;
  description: string;
  image: SanityImageType;
  cta: TemplateButtonProps;
};

export function MeetMentorsSection({ title, description, image, cta }: MeetMentorsSectionProps) {
  return (
    <Section backgroundColor='gray.50'>
      <ContentContainer
        alignItems='center'
        display='flex'
        gap='80px'
        justifyContent='center'
        flexDirection={{
          base: 'column',
          md: 'row',
        }}
      >
        <Box
          flex={{
            base: '1',
            md: '0 2 544px',
          }}
        >
          {title && (
            <HeadingWithEmphasis
              text={title}
              emphasisProps={{
                color: 'blue.500',
                fontWeight: '500',
              }}
              headingProps={{
                size: 'marketing-4xl',
                as: 'h2',
                marginBottom: '16px',
              }}
            />
          )}
          {description && <Markdown markdownText={description} />}
          <Spacer height='48px' />
          {cta && <TemplateButton {...cta} />}
        </Box>

        <Box
          borderRadius='28px 8px 8px 8px'
          overflow='hidden'
          position='relative'
          width='100%'
          height={{
            base: '500px',
            md: '581px',
          }}
          maxWidth={{
            base: '100%',
            md: '544px',
          }}
        >
          <SanityImage
            alt=''
            image={image}
            sizes='544px'
            style={{
              objectFit: 'cover',
            }}
            fill
            priority
          />
        </Box>
      </ContentContainer>
    </Section>
  );
}
